// start:ng42.barrel
import './components';
import './diary.service';
import './directives';
import './transport';
// end:ng42.barrel

